import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment, memo, useContext, useMemo, } from 'react';
import { IconButton } from '../IconButton/index';
import { CondensedPageNumbers } from './CondensedPageNumbers';
import { types } from './constants';
import { ExpandedPageNumbers } from './ExpandedPageNumbers';
import { PaginationContext } from './PaginationContext';
const PaginationControls = () => {
    const { controlType, currentPageNumber, onNextClick, onPageClick, onPrevClick, totalPages, } = (useContext(PaginationContext));
    const isBackButtonDisabled = useMemo(() => (currentPageNumber <= 1), [
        currentPageNumber,
    ]);
    const isForwardButtonDisabled = useMemo(() => (currentPageNumber >= totalPages), [
        currentPageNumber,
        totalPages,
    ]);
    return (_jsxs(Fragment, { children: [_jsx(IconButton, { disabled: isBackButtonDisabled, iconType: "arrow-left", onClick: onPrevClick, size: "large", type: "secondary" }), controlType === types.full
                && (_jsx(ExpandedPageNumbers, {})), controlType === types.compact
                && (_jsx(CondensedPageNumbers, { onPageClick: onPageClick })), _jsx(IconButton, { disabled: isForwardButtonDisabled, iconType: "arrow-right", onClick: onNextClick, size: "large", type: "secondary" })] }));
};
const MemoizedPaginationControls = memo(PaginationControls);
export { MemoizedPaginationControls as PaginationControls };
